import { DraftMessage, DraftMessageLocal } from '../model/types'

export const transformDraftMessageToLocalDraft = (draftMessage: DraftMessage): DraftMessageLocal => {
  const { files } = draftMessage
  let tmpFiles
  if (files && files?.length) {
    tmpFiles = files.map((item) => {
      return {
        url: item.name,
        name: item.file.name,
        type: item.file.type,
      }
    })
  }

  return {
    pServed: draftMessage.pServed,
    files: tmpFiles!,
    messageText: draftMessage.messageText!,
    quotedEventId: draftMessage.quotedEventId!,
    timestamp: draftMessage.timestamp!,
  }
}
